export interface IPageProps {
    isNavCollapsed: boolean;
}

export enum OpenPanelType {
    Add,
    Edit,
    Delete,
}